import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';
import UserProfile from './UserProfile';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

const Header: React.FC = () => {
  const { isLoggedIn, user, isLoading } = useAuth();
  const location = useLocation();

  // Debug log
  useEffect(() => {
    console.log('Header state update:', { isLoggedIn, user: user?.email, location: location.pathname, isLoading });
  }, [isLoggedIn, user, location.pathname, isLoading]);

  return (
    <div className="header-wrapper">
      <header className="app-header">
        <div className="header-container">
          <div className="header-content">
            <Link to="/" className="logo-link">
              <Logo />
            </Link>
            
            <nav className="header-nav">
              <Link to="/pricing" className="nav-link">
                Pricing
              </Link>
              
              {isLoading ? (
                <div className="login-button loading-state">
                  <span className="loading-dots">···</span>
                </div>
              ) : isLoggedIn ? (
                <UserProfile />
              ) : (
                <Link 
                  to="/login" 
                  className="login-button"
                  state={{ from: { pathname: location.pathname } }}
                >
                  Log in
                </Link>
              )}
            </nav>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;

